module.exports = __webpack_public_path__ + "img/bgImg2.ee39d06c.png";